import Store from '@/store/index.js'
import Constant from '@/const'
export default {
  namespaced: true,
  state: {
    ACCESS_TOKEN: null,
    EXPIRES_IN: null,
    REFRESH_TOKEN: null,
    TOKEN_TYPE: null,
    LOGINED: false,
  },
  mutations: {
    create(state, data) {
      if (data.access_token !== undefined)
        state.ACCESS_TOKEN = data.access_token
      if (data.expires_in !== undefined) state.EXPIRES_IN = data.expires_in
      if (data.refresh_token !== undefined)
        state.REFRESH_TOKEN = data.refresh_token
      if (data.token_type !== undefined) state.TOKEN_TYPE = data.token_type
      if (data.logined !== undefined) state.LOGINED = data.logined
    },
    destroy(state) {
      state.ACCESS_TOKEN = null
      state.EXPIRES_IN = null
      state.REFRESH_TOKEN = null
      state.TOKEN_TYPE = null
      state.LOGINED = false
    },
  },
  actions: {
    async login({ commit, dispatch }, data) {
      // 認証
      const request = {
        params: {
          grant_type: 'password',
          client_id: process.env.API.CLIENT_ID,
          client_secret: process.env.API.SECRET_KEY,
          username: data.USER_ID,
          // 管理者アカウントはログインさせない
          password: data.USER_ID.charAt(0) === 'Z' ? null : data.PASSWORD,
          scope: '',
        },
        url: Constant.API_URL.LOGIN,
        error: { message: '正しいIDまたはパスワードをご入力ください。' },
      }
      await dispatch('http/post', { ...request }, { root: true })
        .then((res) => {
          // セッション格納
          commit('create', res.data)
        })
        .catch((err) => {
          throw new Error(err.message)
        })
      // ユーザ情報取得・更新
      return Store.dispatch('user/get').catch((err) => {
        dispatch('destroy', { name: 'all' }).catch((err) => {
          throw new Error(err.message)
        })
        throw new Error(err.message)
      })
    },
    async proxyLogin({ commit, dispatch }, data) {
      const adminId = Store.state.user.data.ID
      await dispatch('login', data)
      await dispatch('update', { name: 'proxy', proxy_user_id: adminId })
    },
    // トップ画面からのログイン処理
    async checkDuplicationLogin({ commit, dispatch }, data) {
      // 認証
      await dispatch('login', data)
      // 同時ログインチェック
      return dispatch('isExistLoginedSameUser')
        .then((res) => {
          if (res) {
            throw new Error(
              '他の利用者が同アカウントにてログイン中の為、ログインに失敗しました。お時間を置いてご利用ください。'
            )
          }
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // ログイン済の同一ユーザが存在するかチェック
    isExistLoginedSameUser({ state, commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${state.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: Constant.API_URL.OAUTH,
        // error: {message: '同一ユーザのログイン人数取得に失敗しました。'}
        error: { message: 'ログイン処理でエラーが発生しました。 code: 101' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res.data > 1
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 認証トークン作成
    create({ commit, dispatch }, data) {
      commit('create', data)
    },
    // 認証トークン削除
    destroy({ state, commit, dispatch }, data = { name: 'all' }) {
      const request = {
        headers: {
          Authorization: `Bearer ${state.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: `${Constant.API_URL.OAUTH}/destroy`,
        // error: {message: 'アクセストークンの削除に失敗しました。'},
        error: { message: 'ログイン処理でエラーが発生しました。 code: 102' },
      }
      commit('destroy')
      return dispatch('http/post', { ...request }, { root: true }).then(
        (res) => {}
      )
    },
    // トークン認証&有効期限の更新
    update(
      { state, commit, dispatch },
      data = {
        name: 'check',
        proxy_user_id: Store.state.user.data.ADMIN_TANTO_ID,
      }
    ) {
      const request = {
        headers: {
          Authorization: `Bearer ${state.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: `${Constant.API_URL.OAUTH}/update`,
        // error: {message: 'トークン認証に失敗しました。'}
        error: { message: 'ログイン処理でエラーが発生しました。 code: 103' },
      }
      return dispatch('http/post', { ...request }, { root: true })
        .then((res) => {
          commit('create', res.data)
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },

    /** 代理ログイン */
    async proxy({ commit, dispatch }, data) {
      const request = {
        url: `${Constant.API_URL.USER}/proxy`,
        params: {
          grant_type: 'password',
          client_id: process.env.API.CLIENT_ID,
          client_secret: process.env.API.SECRET_KEY,
          username: data.USER_ID,
          key: data.KEY,
          time: data.TIME,
        },
      }
      await dispatch('http/post', { ...request }, { root: true }).then(
        (res) => {
          commit('create', res.data)
        }
      )
      await Store.dispatch('user/get')
      Store.commit('user/update', {
        ROLE: Constant.USER.ROLE.ADMIN_MEMBER,
        ADMIN_TANTO_ID: data.ADMIN_ID,
      })
      return dispatch('update', { name: 'proxy', proxy_user_id: data.ADMIN_ID })
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js